@if (message) {
  <div class="error-message">
    <div class="error-message-1">
      <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
    </div>
    <div class="error-message-2" [innerHTML]="message">
    </div>
  </div>
}